/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from 'react';
import { Dropdown } from 'react-bootstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import HeaderDropdownToggle from '../content/CustomDropdowns/HeaderDropdownToggle';
import { ReactComponent as CompilingIcon } from '../../../_metronic/layout/assets/layout-svg-icons/Compiling.svg';
import NotificationListComponent from '../../../components/notification_list/NotificationListComponent';

const perfectScrollbarOptions = {
  wheelSpeed: 2,
  wheelPropagation: false,
};

class UserNotifications extends React.Component {
  state = { key: 'Alerts', open: false, id: null };

  getHeaderTopBarCssClassList = () => {
    let result = 'kt-header__topbar-icon ';
    if (this.props.pulse) {
      result += 'kt-pulse kt-pulse--brand ';
    }

    const { iconType } = this.props;
    if (iconType) {
      result += `kt-header__topbar-icon--${iconType}`;
    }

    return result;
  };

  getSvgCssClassList = () => {
    let result = 'kt-svg-icon ';
    const { iconType } = this.props;
    if (iconType) {
      result += `kt-svg-icon--${iconType}`;
    }

    return result;
  };

  getHetBackGroundCssClassList = () => {
    let result = 'kt-head ';
    if (this.props.skin) {
      result += `kt-head--skin-${this.props.skin} `;
    }

    result += 'kt-head--fit-x';
    return result;
  };

  backGroundStyle = () => {
    if (!this.props.bgImage) {
      return 'none';
    }

    return 'url(' + this.props.bgImage + ')';
  };

  userNotificationsButtonCssClassList = () => {
    let result = 'btn ';
    if (this.props.type) {
      result += `btn-${this.props.type} `;
    }

    result += 'btn-sm btn-bold btn-font-md';
    return result;
  };

  ulTabsClassList = () => {
    let result = 'nav nav-tabs nav-tabs-line nav-tabs-bold nav-tabs-line-3x  ';
    if (this.props.type) {
      result += `nav-tabs-line-${this.props.type} `;
    }

    result += 'kt-notification-item-padding-x';
    return result;
  };

  render() {
    // eslint-disable-next-line no-unused-vars
    const { key } = this.state;
    const { useSVG, icon: NotifIcon, pulse, handleClick, notifyOpen: open, count, notifs } = this.props;

    return (
      <Dropdown className="kt-header__topbar-item" drop="down" alignRight>
        <Dropdown.Toggle as={HeaderDropdownToggle} id="dropdown-toggle-user-notifications">
          <span className={this.getHeaderTopBarCssClassList()}>
            {!useSVG && (
              <div style={{ position: 'relative' }}>
                {count > 0 && (
                  <span
                    className="bg-danger rounded-circle text-light "
                    style={{
                      position: 'absolute',
                      right: -3,
                      fontSize: '10px',
                      top: 13,
                      border: `2px solid #fff`,
                      padding: '0 4px',
                    }}
                  >
                    {count}
                  </span>
                )}
                <NotifIcon />
              </div>
            )}

            {useSVG && (
              <span className={this.getSvgCssClassList()}>
                <CompilingIcon />
              </span>
            )}

            <span className="kt-pulse__ring" hidden={!pulse} />
          </span>
        </Dropdown.Toggle>

        <Dropdown.Menu className="dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-lg">
          <form>
            {/** Head */}
            <div
              className={`${this.getHetBackGroundCssClassList()}`}
              style={{ backgroundImage: this.backGroundStyle() }}
            >
              <h3 className="kt-head__title text-white">اطلاعیه‌ها</h3>
            </div>
            <div>
              <PerfectScrollbar
                options={perfectScrollbarOptions}
                style={{ maxHeight: '100vh', position: 'relative', background: '#e8e8e8' }}
                dir="ltr"
              >
                <div
                  className="kt-notification kt-margin-t-10"
                  style={{ maxHeight: '40vh', position: 'relative' }}
                  dir="rtl"
                >
                  <div
                    className="kt-notification kt-scroll"
                    data-scroll="true"
                    data-height="300"
                    data-mobile-height="200"
                  >
                    <NotificationListComponent notifications={notifs} clickNotification={handleClick} />
                  </div>
                </div>
              </PerfectScrollbar>
            </div>
          </form>
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

export default UserNotifications;
